export default __webpack_public_path__ + "static/media/aboutUs.898c9238.svg";